import { context, tagReplacer } from '@tools/wr-catalog-base'
import { getDuration } from '@utils/product-utils'
import { cleanFormatting, textToHtml, fetchImage } from '@utils/html'
import logo from 'assets/logo.png'
import { get as safeGet } from 'lodash'
import { isNullOrEmptyString } from '@routes/List/utils'

const getRowValue = (item, tag) => {
  const row = item.rows.find((row) => row.options.tag === tag)
  if (!row) return null
  return row.control
}

const formatDate = (date, offsetDays = 0) => {
  date.setDate(date.getDate() + offsetDays)
  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'long' })
  const year = date.getFullYear()
  return `${month} ${day}, ${year}`
}

const wrapperRegex = (tag) => {
  const parts = ['', '/'].map((slash) => {
    const tagPattern = `&lt;${slash}${tag}&gt;`
    return `(?:${tagPattern}|<p*?>${tagPattern}</p>)`
  })
  return new RegExp(parts.join('(.*?)'), 'gs')
}

export default async (props) => {
  const { cart, css, imageHost, template, formValues, region, cartTotals, asQuoteWord } = props
  const date = new Date()
  const monthName = date.toLocaleString('default', { month: 'long' })
  const div = document.createElement('div')

  const itemRx = wrapperRegex('itemSubTemplate')
  let subTl
  let html = template?.content.replace(itemRx, (m, p1) => {
    subTl = p1
    return ''
  })

  html += cart
    .map((item) => {
      const regionName = context.utils.getRegionName()
      const pricingRow = item.rows.find((r) => r.rowType === 'component:pricing')
      const points = context.utils.product.getPointPrice(item)
      const hours = getDuration(item)

      div.innerHTML = getRowValue(item, 'schedule') || ''
      const table = div.querySelector('table')
      if (table) table.style.width = '100%'
      const scheduleTable = div.innerHTML

      const replacements = {}
      item.rows.forEach((row, i) => {
        const tag = row?.options?.tag
        if (tag) {
          const cleanTag = tag.replace(/^<|>$/g, '')
          replacements[cleanTag] = cleanFormatting(row.control || '')
          if (row.rowType === 'editor' && row.label && !/^\s*outcome\s*$/i.test(cleanTag)) {
            replacements[cleanTag] =
              `<h2 class="node--closer-down">${textToHtml(row.label)}</h2>` + replacements[cleanTag]
          }
        }
      })
      let name = item.name
      const ptcUrl = item.rows.find((row) => String(row.options.tag).toLowerCase() === '<ptc url>')
      if (ptcUrl) {
        const div = document.createElement('div')
        div.innerHTML = ptcUrl.control
        name = `<a href="${div.textContent.trim()}" target="_blank" rel="noopener noreferrer">${name}</a>`
      }
      Object.assign(replacements, {
        name,
        overview: item.description,
        'points-hours': points
          ? `${points} points | ${hours} hours`
          : !!pricingRow &&
            (isNullOrEmptyString(pricingRow.control.constants.find((cons) => cons.name === regionName)?.value)
              ? safeGet(pricingRow.control, 'schedule.serviceRateLabel')
              : 'Not available in Region'),
        schedule: scheduleTable,
      })
      const subHtml = Object.entries(replacements).reduce(
        (subHtml, [tag, replacement]) => tagReplacer(subHtml, tag, replacement),
        subTl,
      )
      return `
      <div class="page-break"></div>
      ${subHtml}
    `
    })
    .join('\n')

  html = tagReplacer(html, 'date', formatDate(new Date()))
  html = tagReplacer(html, 'expiration-date', formatDate(new Date(), 60))
  html = tagReplacer(html, 'points', cartTotals.totalPoints)
  html = tagReplacer(html, 'hours', `${cartTotals.totalHours} hours`)
  html = tagReplacer(html, 'region', region)
  html = tagReplacer(html, 'hr', '<div class="separator"></div>')
  html = tagReplacer(html, 'page_break', '<br style="page-break-before: always; clear: both" />')

  let images = [`${imageHost}/sow-assets/success-services-cover.jpg`]
  if (asQuoteWord) {
    images = await Promise.all(images.map(fetchImage))
  }

  // Utility to insert the first arg of the condition if we're building a docx, inserts the second option otherwise
  const W = (whenTrue, otherwise = '') => (asQuoteWord ? whenTrue : otherwise)

  return `<!DOCTYPE html>
<html>
  <head>
    <title>PTC Catalog Export.pdf</title>
    ${W('', `<style>${css}</style>`)}
  </head>
  <body>
    ${W(`<style>${css}</style>`)}
    <div class="page title-page" style="${W('', `background-image: url(${images[0]});`)}">
      ${W(
        `<img hspace="0" style="width:210mm;height:297mm;margin:0;padding:0; bottom: 0; left: 0;" src="${images[0]}" />`,
      )}
      <div class="title-backdrop" ${W('style="width: 105mm; left: 105mm;"')}>
        <div class="title-backdrop-stripes"></div>
        <div class="title-backdrop-layout">
          <div>
            ${W(
              `<div>
                <img src="${imageHost}${logo}" alt="brand logo" class="title-header-logo" style="width: 56px; height: 22px; display: inline-block;" />
                <div style="display: inline; font-size: 32px;">customer <br/>success</div>
              </div>`,
              `<div class="title-header">
                <img src="${imageHost}${logo}" alt="brand logo" class="title-header-logo" />
                <div class="title-header-text">customer<br />success</div>
              </div>`,
            )}
            <div class="title">
              SUCCESS SERVICE PROPOSAL
              <div class="subtitle">
                PTC Customer Success
              </div>
            </div>
          </div>
          <div class="title-backdrop-footer">
            ${formValues.company}<br>
            <span class="date" ${W(
              'style="font-size: 26px;"',
            )}>${monthName} ${date.getDate()}, ${date.getFullYear()}</span>
          </div>
        </div>
      </div>

      <div class="cover-upper-line"></div>
      <div class="cover-lower-line"></div>
    </div>
    <table style="margin: 0px 50px">
      <thead><tr><td><div style="height: 100px">&nbsp;</div></td></tr></thead>
      <tbody>
        <tr>
          <td ${W('style="margin: 0 50px"')}>${html}</td>
        </tr>
      </tbody>
      <tfoot><tr><td><div style="height: 70px">&nbsp;</div></td></tr></tfoot>
    </table>
    ${W(
      '',
      `<div class="doc-footer">
        <div class="doc-footer-header"></div>
        <div class="doc-footer-left-notch"></div>
        <div class="doc-footer-footer">
          <div>
            <span class="text--active">Page&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> |
            Success Path Proposal
          </div>
          <div>
            <a href="http://www.ptc.com/success-paths">http://www.ptc.com/success-paths</a>
          </div>
        </div>
      </div>`,
    )}
  </body>
</html>
`
}
